import { render, staticRenderFns } from "./v80Menu.vue?vue&type=template&id=bf9f2490&scoped=true&"
import script from "./v80Menu.vue?vue&type=script&lang=js&"
export * from "./v80Menu.vue?vue&type=script&lang=js&"
import style0 from "./v80Menu.vue?vue&type=style&index=0&id=bf9f2490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9f2490",
  null
  
)

export default component.exports